import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useListVals, useObject } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { Card, List, message } from "antd";
import { Button, Dialog } from "evergreen-ui";
import YesNoPieChart from "./Charts/YesNoPieChart";
import LinearScaleBarChart from "./Charts/LinearScaleBarChart";
import ChoiceBarChart from "./Charts/ChoiceBarChart";
import { utils, writeFile } from "xlsx";
import moment from "moment";
import { getAuth, onAuthStateChanged } from "firebase/auth";

var db = getDatabase(Firebase);
var auth = getAuth(Firebase);
const SurveyResponses = () => {
  const location = useLocation();
  const { id } = useParams();
  const [questions] = useListVals(ref(db, `talmidsdb/surveys/${id}/questions`));
  const [questionArray, setQuestionArray] = useState([]);
  const [responseArray, setResponseArray] = useState([]);
  const [responses, loading] = useListVals(ref(db, "talmidsdb/surveyResponses"));
  const [users] = useListVals(ref(db, "talmidsdb/users"));
  const [snapshot] = useObject(ref(db, "talmidsdb/surveys/" + id));
  const [survey, setSurvey] = useState();
  const [submitterArray, setSubmitterArray] = useState([]);
  const [openSubmitters, setOpenSubmitters] = useState(false);
  const [activeQuest, setActiveQuest] = useState("");
  const [canSeeSubmitter, setCanSeeSubmitter] = useState(false);

  useEffect(() => {
    if (location.state?.survey === undefined) {
      window.location.href = "/surveys"
    }

    onAuthStateChanged(auth, function (user) {
      if (user) {
        var use = users.find(x => (user.uid) === x.id);
        var role = use?.userRole;

        console.log(role);
        switch (role) {
          case "SuperUser":
            setCanSeeSubmitter(true);
            break;

          case "RegIntlOrgStaff":
            setCanSeeSubmitter(true);
            break;

          default:
            setCanSeeSubmitter(false);
        }
      }
    })
    var questArray = [];
    if (snapshot) {
      setSurvey(snapshot?.val());
    }

    if (responses) {
      questArray = [...(questions || [])].sort((a, b) => Number(a.questionIndex ?? 0) - Number(b.questionIndex ?? 0));
      var resArray = responses.filter(x => x.surveyID === id);

      var subArray = [];
      questArray.map((question, i) => {
        var questionID = question.questionID;
        var array = [];
        resArray.map((response, j) => {
          var answer = response.responses[questionID];
          array.push(answer);
          subArray.push({ submitter: response.userID, questionID: questionID, timestamp: response.timeStamp })
        });
        question.answers = array;
      });

      console.log(subArray);
      setSubmitterArray([...subArray]);
      setResponseArray([...resArray])
      setQuestionArray([...questArray]);
    }

  }, [id, location.state?.survey, questions, responses, snapshot, users]);

  const downloadExcel = (data) => {
    const worksheet = utils.json_to_sheet(data);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Sheet1");
    writeFile(workbook, "responses.xlsx");
  };

  return (
    <div className="d-flex flex-column">
      <div style={{ marginBottom: 10 }} className="d-flex justify-content-end">

        <b className="mx-2" onClick={() => { }}>

        </b>
        <Button appearance="primary" className="mx-2" onClick={() => {
          // print the results in json format


          var tempArray = [];
          responseArray.map((res) => {
            var object = {};
            Object.entries(res.responses).map(([key, value]) => {
              var question = questionArray.find(x => x.questionID === key);
              object[question?.question] = value;
            });
            object["timeStamp"] = res.timeStamp ? res.timeStamp : res.timestamp;
            tempArray.push(object);
          });

          downloadExcel(tempArray);
        }}>
          Print
        </Button>
      </div>
      <Dialog
        isShown={openSubmitters}
        title="Submitters"
        onCloseComplete={() => { setOpenSubmitters(false) }}
        className="font-Nunito"
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
      >
        <List
          itemLayout="horizontal"
          dataSource={submitterArray.filter(x => x.questionID === activeQuest)}
          renderItem={item => (
            <List.Item>
              <List.Item.Meta
                title={users[users.findIndex(x => x.id === item.submitter)]?.firstname + " " +
                  users[users.findIndex(x => x.id === item.submitter)]?.surname}
                description={moment(item.timestamp).format("DD MMM YYYY HH:MM")}
              />
            </List.Item>
          )}
        />
      </Dialog>
      <List
        itemLayout="vertical"
        loading={loading}
        dataSource={questionArray}
        renderItem={(field, index) => (
          <List.Item
            key={field.questionID}>
            <Card title={
              <div className="d-flex justify-content-between mr-4">
                <b>{field.question}</b>
                <p className="mr-4 text-decoration-underline blue-text" onClick={() => {
                  if (canSeeSubmitter) {
                    setActiveQuest(field.questionID);
                    setOpenSubmitters(true);
                  } else {
                    message.error("You don't have permission to view survey submitters")
                  }
                }}><a>{field.answers?.length} responses</a></p>
              </div>
            }>
              {field.answerType === "Long answer" || field.answerType === "Short answer" ?
                <div className="d-flex flex-column anotherScroll">
                  {field.answers.map((answer) => (
                    <Card className="my-1 w-100 bg-gray">{answer}</Card>
                  ))}
                </div>

                :
                null
              }
              {field.answerType === "Yes/No" ?
                <div className="d-flex justify-content-center align-items-center">
                  <YesNoPieChart answers={field.answers} />
                </div>

                :
                null
              }
              {field.answerType === "Linear Scale" ?
                <div className="d-flex justify-content-center align-items-center">
                  <LinearScaleBarChart question={field} />
                </div>

                :
                null
              }

              {field.answerType === "Multiple Choice (One answer)" ?
                <div className="d-flex justify-content-center align-items-center">
                  <ChoiceBarChart question={field} />
                </div>

                :
                null
              }

            </Card>

          </List.Item>
        )}>
      </List>
    </div>
  )
}

export default SurveyResponses;
